export default __webpack_public_path__ + "29e696f6e0c1e4eb9342bd8d795002b7.jpg";